import React from "react";
import { TaskData, TaskControlsAction, TaskStatus } from "../../types/tasks.types";
import { TaskTable } from "./tasktable";
import { ConfirmPane, ConfirmPaneLockScroll } from "../../components/confirmpane";
import { DOWNLOAD_STRING } from "./taskcontrols";
import { capitalizeFirst } from "../../utils/utils";
import { makeTaskLinkWithPageDir } from "../../utils/linkbuilder";
import LinkPane from "../../components/linkpane";

export const getEmptyTasksData = function():TaskData{
	return{
		metaData:{ contentType: '', contentTitle: '', creatorMail:'', taskTitle:'', pageDir: '', scoreType: '', taskOptions: []},
		tableData:[]
	}
}

const CONFIRM_MSG_DELETE = "Delete this task?";
const CONFIRM_MSG_RESET = "Delete all records?";
const LINK_MSG="Link to this task";
const NOT_LOGGED_IN_MSG: React.ReactElement = <p className='teachers-statusmessage'>Not logged in</p>;

interface PropsType {
	oneTasksData: TaskData;
	taskStatus: TaskStatus;
	taskControlsClick: (action: TaskControlsAction, taskTitle: string) => void;
	usermail: string;
}

interface StateType {
	showConfirm: boolean;
	showConfirmAction: TaskControlsAction;
}

export default class TasksView extends React.Component<PropsType> {

	public state: StateType;

	constructor(props: PropsType) {
		super(props);

		this.state = {
			showConfirm: false,
			showConfirmAction: TaskControlsAction.Delete,
		}

		this.confirmClick = this.confirmClick.bind(this);
		this.controlsClick = this.controlsClick.bind(this);
	}

	confirmClick(isConfirmed: boolean) {
		ConfirmPaneLockScroll(false);
		this.setState({
			showConfirm: false
		});
		if (isConfirmed) {
			this.props.taskControlsClick(this.state.showConfirmAction, this.props.oneTasksData.metaData.taskTitle);
		}
	}

	controlsClick(clickType: string) {
		if (clickType === DOWNLOAD_STRING) {
			this.downloadTableData();
		} else {
			ConfirmPaneLockScroll(true);
			this.setState({
				showConfirm: true,
				showConfirmAction: clickType as TaskControlsAction
			});
		}
	}

	getConfirmMessage() {
		if (this.state.showConfirmAction === TaskControlsAction.Delete) return CONFIRM_MSG_DELETE;
		if (this.state.showConfirmAction === TaskControlsAction.Reset) return CONFIRM_MSG_RESET;
		return '';
	}

	downloadTableData() {
		let scoreType = this.props.oneTasksData.metaData.scoreType;
		let scoreTitle = capitalizeFirst(scoreType);
		let csvObj = [['', 'Name', 'Complete', scoreTitle]];
		this.props.oneTasksData.tableData.forEach((entry) => {
			let csvScore = entry.score === -1 ? '' : entry.score;
			csvObj.push([entry.rank.toString(), entry.name, entry.complete, csvScore.toString()])
		});
		let csvRows = [];
		for (let i = 0, l = csvObj.length; i < l; ++i) {
			csvRows.push(csvObj[i].join(','));
		}
		var csvString = csvRows.join("%0A");
		var myCsvAnchor = document.createElement('a');
		myCsvAnchor.href = 'data:attachment/csv,' + csvString;
		myCsvAnchor.target = '_blank';
		myCsvAnchor.download = this.props.oneTasksData.metaData.taskTitle + '.csv';
		document.body.appendChild(myCsvAnchor);
		myCsvAnchor.click();
	}

	render() {
		if (this.props.usermail === '') return NOT_LOGGED_IN_MSG;

		return (
			<div id='teachers-viewtasks'>
				<TaskInfo
					taskTitle={this.props.oneTasksData.metaData.taskTitle}
					taskStatus={this.props.taskStatus} />
				<TaskTable
					taskData={this.props.oneTasksData} />
				<TaskControls
					taskTitle={this.props.oneTasksData.metaData.taskTitle}
					taskStatus={this.props.taskStatus}
					controlsClick={this.controlsClick} />
				<TaskLink
					usermail={this.props.usermail}
					taskData={this.props.oneTasksData} />
				<ConfirmPane
					showConfirm={this.state.showConfirm}
					confirmClick={this.confirmClick}
					confirmMessage={this.getConfirmMessage()} />
			</div>
		);
	}
}

const TaskInfo=function(props:{taskTitle:string, taskStatus:TaskStatus}){
	let myTitle=capitalizeFirst(props.taskTitle);
	let statusMsg='';
	if(props.taskStatus===TaskStatus.GetTask)statusMsg="Loading task data...";
	if(props.taskStatus===TaskStatus.GetTaskDataError)statusMsg="Error getting data for this task - Try again";
	if(props.taskStatus===TaskStatus.GetTaskMetaError)statusMsg="Error with this task";
	if(props.taskStatus===TaskStatus.ResetTask)statusMsg="Resetting task data...";
	if(props.taskStatus===TaskStatus.ResetTaskFailed)statusMsg="Reset failed";
	if(props.taskStatus===TaskStatus.DeleteTask)statusMsg="Deleting task...";
	if(props.taskStatus===TaskStatus.DeleteTaskFailed)statusMsg="Delete failed";

	let displayTitle=props.taskTitle.replace(/_/g, ' ');

	return(
		<div>
			<hr />
			{myTitle!==''&&<h3>{displayTitle}</h3>}
			{myTitle!==''&&<hr />}
			{statusMsg!==''&&<p className="teachers-statusmessage">{statusMsg}</p>}
		</div>
	)
};

const TaskControls=function(props:{taskTitle:string, taskStatus:TaskStatus,controlsClick:(action: string | TaskControlsAction) => void}){
	if(props.taskTitle==='')return null;
	if(props.taskStatus===TaskStatus.GetList)return null;
	if(props.taskStatus===TaskStatus.GetListError)return null;
	if(props.taskStatus===TaskStatus.GetTask)return null;
	if(props.taskStatus===TaskStatus.ResetTask)return null;
	if(props.taskStatus===TaskStatus.DeleteTask)return null;
	if(props.taskStatus===TaskStatus.DeleteTaskFailed)return null;
	if(props.taskStatus===TaskStatus.ResetTaskFailed)return null;

	return(
		<div className='teachers-task-controls'>
			<button onClick={()=>{props.controlsClick(DOWNLOAD_STRING);}} className='teachers-button teachers-button-light'>Download</button>
			<button onClick={()=>{props.controlsClick(TaskControlsAction.Reset);}} className='teachers-button teachers-button-light'>Reset</button>
			<button onClick={()=>{props.controlsClick(TaskControlsAction.Delete);}} className='teachers-button teachers-button-light'>Delete</button>
		</div>
	  );
};

const TaskLink=function(props:{taskData:TaskData, usermail:string}){
	if(props.taskData.metaData.taskTitle==='')return null;
	let myURL=makeTaskLinkWithPageDir(props.taskData.metaData.pageDir,props.usermail,props.taskData.metaData.taskTitle);
	return(
		<div>
			<hr />
			<p>{LINK_MSG}</p>
			<LinkPane linkURL={myURL} />
		</div>
	)
};
